import { Component, Inject } from '@angular/core';
import { Capa, CapaStatus } from '../../audit.model';
import { CapaService } from '../../capa.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'iaud-capa-edit-dialog',
  templateUrl: './capa-edit-dialog.component.html',
  styleUrls: ['./capa-edit-dialog.component.scss']
})
export class CapaEditDialogComponent {

  capa: Capa;
  isFormValid: boolean;
  capaStatus: CapaStatus;
  isSaving$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isSavingLater$: BehaviorSubject<boolean> = new BehaviorSubject(false);  

  constructor(
    private capaService: CapaService,
    public dialogRef: MatDialogRef<CapaEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.capa = {...data.capa};
  }

  update(markAsReady): void {
    if (markAsReady) {
      this.capa.status = CapaStatus.READY_TO_SUBMIT;
      this.isSaving$.next(true);
    } else {
      this.capa.status = CapaStatus.DRAFT;
      this.isSavingLater$.next(true);
    }
    this.capaService.updateCapa(this.capa)
    .subscribe(response => {
      this.dialogRef.close({capaId: response, success: true});
    });
  }

  toggleFormValidity(valid: boolean): void {
    this.isFormValid = valid;
  }

}
